/**
 * Operation Descriptor
 *
 * Canonical definition of every API operation that requires authorization.
 * Branch is the sole organization sub-scope in application contracts. Legacy
 * branch storage identifiers are confined to the persistence boundary.
 */
export var AuthenticationAssuranceLevel;
(function (AuthenticationAssuranceLevel) {
    AuthenticationAssuranceLevel["AAL1"] = "AAL1";
    AuthenticationAssuranceLevel["AAL2"] = "AAL2";
})(AuthenticationAssuranceLevel || (AuthenticationAssuranceLevel = {}));
export var ScopeType;
(function (ScopeType) {
    ScopeType["ORGANIZATION"] = "ORGANIZATION";
    ScopeType["BRANCH"] = "BRANCH";
    ScopeType["CLIENT"] = "CLIENT";
    ScopeType["PORTFOLIO"] = "PORTFOLIO";
    ScopeType["PLATFORM"] = "PLATFORM";
    ScopeType["SYSTEM"] = "SYSTEM";
})(ScopeType || (ScopeType = {}));
export var AuditPolicy;
(function (AuditPolicy) {
    AuditPolicy["NONE"] = "NONE";
    AuditPolicy["READ"] = "READ";
    AuditPolicy["WRITE"] = "WRITE";
    AuditPolicy["SENSITIVE"] = "SENSITIVE";
})(AuditPolicy || (AuditPolicy = {}));
export var IdempotencyPolicy;
(function (IdempotencyPolicy) {
    IdempotencyPolicy["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    IdempotencyPolicy["REQUIRED"] = "REQUIRED";
    IdempotencyPolicy["OPTIONAL"] = "OPTIONAL";
})(IdempotencyPolicy || (IdempotencyPolicy = {}));
export var ConcurrencyPolicy;
(function (ConcurrencyPolicy) {
    ConcurrencyPolicy["NONE"] = "NONE";
    ConcurrencyPolicy["ADVISORY_LOCK"] = "ADVISORY_LOCK";
    ConcurrencyPolicy["OPTIMISTIC"] = "OPTIMISTIC_VERSION";
    ConcurrencyPolicy["OPTIMISTIC_VERSION"] = "OPTIMISTIC_VERSION";
    ConcurrencyPolicy["PESSIMISTIC_LOCK"] = "PESSIMISTIC_LOCK";
})(ConcurrencyPolicy || (ConcurrencyPolicy = {}));
export var PrivacyClassification;
(function (PrivacyClassification) {
    PrivacyClassification["PUBLIC"] = "PUBLIC";
    PrivacyClassification["INTERNAL"] = "INTERNAL";
    PrivacyClassification["CONFIDENTIAL"] = "CONFIDENTIAL";
    PrivacyClassification["RESTRICTED"] = "RESTRICTED";
})(PrivacyClassification || (PrivacyClassification = {}));
export var ActorType;
(function (ActorType) {
    ActorType["USER"] = "USER";
    ActorType["CLIENT"] = "CLIENT";
    ActorType["SUPPORT_DELEGATE"] = "SUPPORT_DELEGATE";
    ActorType["SYSTEM"] = "SYSTEM";
    ActorType["SERVICE_ACCOUNT"] = "SERVICE_ACCOUNT";
})(ActorType || (ActorType = {}));
export function getOperationDescriptor(registry, operationId) {
    return registry[operationId];
}
export function hasOperationDescriptor(registry, operationId) {
    return operationId in registry;
}
